const PaisesOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: 'AFGANISTAN (EMIRATO ISLAMICO DE) ',
    value: 'AF'
  },
  {
    label: 'ALBANIA (REPUBLICA DE) ',
    value: 'AL'
  },
  {
    label: 'ALEMANIA (REPUBLICA FEDERAL DE) ',
    value: 'DE'
  },
  {
    label: 'ANDORRA (PRINCIPADO DE) ',
    value: 'AD'
  },
  {
    label: 'ANGOLA (REPUBLICA DE) ',
    value: 'AO'
  },
  {
    label: 'ANGUILA ',
    value: 'AI'
  },
  {
    label: 'ANTARTIDA ',
    value: 'AQ'
  },
  {
    label: 'ANTIGUA Y BARBUDA (COMUNIDAD BRITANICA DE NACIONES) ',
    value: 'AG'
  },
  {
    label: 'ANTILLAS NEERLANDESAS (TERRITORIO HOLANDES DE ULTRAMAR) ',
    value: 'AN'
  },
  {
    label: 'ARABIA SAUDITA (REINO DE) ',
    value: 'SA'
  },
  {
    label: 'ARGELIA (REPUBLICA DEMOCRATICA Y POPULAR DE) ',
    value: 'DZ'
  },
  {
    label: 'ARGENTINA (REPUBLICA) ',
    value: 'AR'
  },
  {
    label: 'ARMENIA (REPUBLICA DE) ',
    value: 'AM'
  },
  {
    label: 'ARUBA (TERRITORIO HOLANDES DE ULTRAMAR) ',
    value: 'AW'
  },
  {
    label: 'AUSTRALIA (COMUNIDAD DE) ',
    value: 'AU'
  },
  {
    label: 'AUSTRIA (REPUBLICA DE) ',
    value: 'AT'
  },
  {
    label: 'AZERBAIJAN (REPUBLICA AZERBAIJANI) ',
    value: 'AZ'
  },
  {
    label: 'BAHAMAS (COMUNIDAD DE LAS) ',
    value: 'BS'
  },
  {
    label: 'BAHREIN (ESTADO DE) ',
    value: 'BH'
  },
  {
    label: 'BANGLADESH (REPUBLICA POPULAR DE) ',
    value: 'BD'
  },
  {
    label: 'BARBADOS (COMUNIDAD BRITANICA DE NACIONES) ',
    value: 'BB'
  },
  {
    label: 'BELGICA (REINO DE) ',
    value: 'BE'
  },
  {
    label: 'BELICE ',
    value: 'BZ'
  },
  {
    label: 'BENIN (REPUBLICA DE) ',
    value: 'BJ'
  },
  {
    label: 'BERMUDAS ',
    value: 'BM'
  },
  {
    label: 'BIELORRUSIA (REPUBLICA DE) ',
    value: 'BY'
  },
  {
    label: 'BOLIVIA (REPUBLICA DE) ',
    value: 'BO'
  },
  {
    label: 'BOSNIA Y HERZEGOVINA ',
    value: 'BA'
  },
  {
    label: 'BOTSWANA (REPUBLICA DE) ',
    value: 'BW'
  },
  {
    label: 'BRASIL (REPUBLICA FEDERATIVA DE) ',
    value: 'BR'
  },
  {
    label: 'BRUNEI (ESTADO DE) (RESIDENCIA DE PAZ) ',
    value: 'BN'
  },
  {
    label: 'BULGARIA (REPUBLICA DE) ',
    value: 'BG'
  },
  {
    label: 'BURKINA FASO ',
    value: 'BF'
  },
  {
    label: 'BURUNDI (REPUBLICA DE) ',
    value: 'BI'
  },
  {
    label: 'BUTAN (REINO DE) ',
    value: 'BT'
  },
  {
    label: 'CABO VERDE (REPUBLICA DE) ',
    value: 'CV'
  },
  {
    label: 'CHAD (REPUBLICA DEL) ',
    value: 'TD'
  },
  {
    label: 'CAIMAN (ISLAS) ',
    value: 'KY'
  },
  {
    label: 'CAMBOYA (REINO DE) ',
    value: 'KH'
  },
  {
    label: 'CAMERUN (REPUBLICA DEL) ',
    value: 'CM'
  },
  {
    label: 'CANADA ',
    value: 'CA'
  },
  {
    label: 'CHILE (REPUBLICA DE) ',
    value: 'CL'
  },
  {
    label: 'CHINA (REPUBLICA POPULAR) ',
    value: 'CN'
  },
  {
    label: 'CHIPRE (REPUBLICA DE) ',
    value: 'CY'
  },
  {
    label: 'CIUDAD DEL VATICANO (ESTADO DE LA) ',
    value: 'VA'
  },
  {
    label: 'COCOS (KEELING, ISLAS AUSTRALIANAS) ',
    value: 'CC'
  },
  {
    label: 'COLOMBIA (REPUBLICA DE) ',
    value: 'CO'
  },
  {
    label: 'COMORAS (ISLAS) ',
    value: 'KM'
  },
  {
    label: 'CONGO (REPUBLICA DEL) ',
    value: 'CG'
  },
  {
    label: 'COOK (ISLAS) ',
    value: 'CK'
  },
  {
    label: 'COREA (REPUBLICA POPULAR DEMOCRATICA DE) (COREA DEL NORTE) ',
    value: 'KP'
  },
  {
    label: 'COREA (REPUBLICA DE) (COREA DEL SUR) ',
    value: 'KR'
  },
  {
    label: 'COSTA DE MARFIL (REPUBLICA DE LA) ',
    value: 'CI'
  },
  {
    label: 'COSTA RICA (REPUBLICA DE) ',
    value: 'CR'
  },
  {
    label: 'CROACIA (REPUBLICA DE) ',
    value: 'HR'
  },
  {
    label: 'CUBA (REPUBLICA DE) ',
    value: 'CU'
  },
  {
    label: 'DINAMARCA (REINO DE) ',
    value: 'DK'
  },
  {
    label: 'DJIBOUTI (REPUBLICA DE) ',
    value: 'DJ'
  },
  {
    label: 'DOMINICA (COMUNIDAD DE) ',
    value: 'DM'
  },
  {
    label: 'ECUADOR (REPUBLICA DEL) ',
    value: 'EC'
  },
  {
    label: 'EGIPTO (REPUBLICA ARABE DE) ',
    value: 'EG'
  },
  {
    label: 'EL SALVADOR (REPUBLICA DE) ',
    value: 'SV'
  },
  {
    label: 'EMIRATOS ARABES UNIDOS ',
    value: 'AE'
  },
  {
    label: 'ERITREA (ESTADO DE) ',
    value: 'ER'
  },
  {
    label: 'ESLOVENIA (REPUBLICA DE) ',
    value: 'SI'
  },
  {
    label: 'ESPAÑA (REINO DE) ',
    value: 'ES'
  },
  {
    label: 'ESTADO FEDERADO DE MICRONESIA ',
    value: 'FM'
  },
  {
    label: 'ESTADOS UNIDOS DE AMERICA ',
    value: 'US'
  },
  {
    label: 'ESTONIA (REPUBLICA DE) ',
    value: 'EE'
  },
  {
    label: 'ETIOPIA (REPUBLICA DEMOCRATICA FEDERAL) ',
    value: 'ET'
  },
  {
    label: 'FIDJI (REPUBLICA DE) ',
    value: 'FJ'
  },
  {
    label: 'FILIPINAS (REPUBLICA DE LAS) ',
    value: 'PH'
  },
  {
    label: 'FINLANDIA (REPUBLICA DE) ',
    value: 'FI'
  },
  {
    label: 'FRANCIA (REPUBLICA FRANCESA) ',
    value: 'FR'
  },
  {
    label: 'GABONESA (REPUBLICA) ',
    value: 'GA'
  },
  {
    label: 'GAMBIA (REPUBLICA DE LA) ',
    value: 'GM'
  },
  {
    label: 'GEORGIA (REPUBLICA DE) ',
    value: 'GE'
  },
  {
    label: 'GHANA (REPUBLICA DE) ',
    value: 'GH'
  },
  {
    label: 'GIBRALTAR (R.U.) ',
    value: 'GI'
  },
  {
    label: 'GRANADA ',
    value: 'GD'
  },
  {
    label: 'GRECIA (REPUBLICA HELENICA) ',
    value: 'GR'
  },
  {
    label: 'GROENLANDIA (DINAMARCA) ',
    value: 'GL'
  },
  {
    label: 'GUADALUPE (DEPARTAMENTO DE) ',
    value: 'GP'
  },
  {
    label: 'GUAM (E.U.A.) ',
    value: 'GU'
  },
  {
    label: 'GUATEMALA (REPUBLICA DE) ',
    value: 'GT'
  },
  {
    label: 'GUERNSEY ',
    value: 'GG'
  },
  {
    label: 'GUINEA-BISSAU (REPUBLICA DE) ',
    value: 'GW'
  },
  {
    label: 'GUINEA ECUATORIAL (REPUBLICA DE) ',
    value: 'GQ'
  },
  {
    label: 'GUINEA (REPUBLICA DE) ',
    value: 'GN'
  },
  {
    label: 'GUYANA FRANCESA ',
    value: 'GF'
  },
  {
    label: 'GUYANA (REPUBLICA COOPERATIVA DE) ',
    value: 'GY'
  },
  {
    label: 'HAITI (REPUBLICA DE) ',
    value: 'HT'
  },
  {
    label: 'HONDURAS (REPUBLICA DE) ',
    value: 'HN'
  },
  {
    label: 'HONG KONG (REGION ADMINISTRATIVA ESPECIAL DE LA REPUBLICA) ',
    value: 'HK'
  },
  {
    label: 'HUNGRIA (REPUBLICA DE) ',
    value: 'HU'
  },
  {
    label: 'INDIA (REPUBLICA DE) ',
    value: 'IN'
  },
  {
    label: 'INDONESIA (REPUBLICA DE) ',
    value: 'ID'
  },
  {
    label: 'IRAK (REPUBLICA DE) ',
    value: 'IQ'
  },
  {
    label: 'IRAN (REPUBLICA ISLAMICA DEL) ',
    value: 'IR'
  },
  {
    label: 'IRLANDA (REPUBLICA DE) ',
    value: 'IE'
  },
  {
    label: 'ISLANDIA (REPUBLICA DE) ',
    value: 'IS'
  },
  {
    label: 'ISLA BOUVET ',
    value: 'BV'
  },
  {
    label: 'ISLA DE MAN ',
    value: 'IM'
  },
  {
    label: 'ISLAS ALAND ',
    value: 'AX'
  },
  {
    label: 'ISLAS FEROE ',
    value: 'FO'
  },
  {
    label: 'ISLAS GEORGIA Y SANDWICH DEL SUR ',
    value: 'GS'
  },
  {
    label: 'ISLAS HEARD Y MCDONALD ',
    value: 'HM'
  },
  {
    label: 'ISLAS MALVINAS (R.U.) ',
    value: 'FK'
  },
  {
    label: 'ISLAS MARIANAS SEPTENTRIONALES ',
    value: 'MP'
  },
  {
    label: 'ISLAS MARSHALL ',
    value: 'MH'
  },
  {
    label: 'ISLAS MENORES DE ULTRAMAR DE ESTADOS UNIDOS DE AMERICA ',
    value: 'UM'
  },
  {
    label: 'ISLAS SALOMON (COMUNIDAD BRITANICA DE NACIONES) ',
    value: 'SB'
  },
  {
    label: 'ISLAS SVALBARD Y JAN MAYEN (NORUEGA) ',
    value: 'SJ'
  },
  {
    label: 'ISLAS TOKELAU ',
    value: 'TK'
  },
  {
    label: 'ISLAS WALLIS Y FUTUNA ',
    value: 'WF'
  },
  {
    label: 'ISRAEL (ESTADO DE) ',
    value: 'IL'
  },
  {
    label: 'ITALIA (REPUBLICA ITALIANA) ',
    value: 'IT'
  },
  {
    label: 'JAMAICA ',
    value: 'JM'
  },
  {
    label: 'JAPON ',
    value: 'JP'
  },
  {
    label: 'JERSEY ',
    value: 'JE'
  },
  {
    label: 'JORDANIA (REINO HACHEMITA DE) ',
    value: 'JO'
  },
  {
    label: 'KAZAKHSTAN (REPUBLICA DE) ',
    value: 'KZ'
  },
  {
    label: 'KENYA (REPUBLICA DE) ',
    value: 'KE'
  },
  {
    label: 'KIRIBATI (REPUBLICA DE) ',
    value: 'KI'
  },
  {
    label: 'KUWAIT (ESTADO DE) ',
    value: 'KW'
  },
  {
    label: 'KYRGYZSTAN (REPUBLICA KIRGYZIA) ',
    value: 'KG'
  },
  {
    label: 'LESOTHO (REINO DE) ',
    value: 'LS'
  },
  {
    label: 'LETONIA (REPUBLICA DE) ',
    value: 'LV'
  },
  {
    label: 'LIBANO (REPUBLICA DE) ',
    value: 'LB'
  },
  {
    label: 'LIBERIA (REPUBLICA DE) ',
    value: 'LR'
  },
  {
    label: 'LIBIA (JAMAHIRIYA LIBIA ARABE POPULAR SOCIALISTA) ',
    value: 'LY'
  },
  {
    label: 'LIECHTENSTEIN (PRINCIPADO DE) ',
    value: 'LI'
  },
  {
    label: 'LITUANIA (REPUBLICA DE) ',
    value: 'LT'
  },
  {
    label: 'LUXEMBURGO (GRAN DUCADO DE) ',
    value: 'LU'
  },
  {
    label: 'MACAO ',
    value: 'MO'
  },
  {
    label: 'MACEDONIA (ANTIGUA REPUBLICA YUGOSLAVA DE) ',
    value: 'MK'
  },
  {
    label: 'MADAGASCAR (REPUBLICA DE) ',
    value: 'MG'
  },
  {
    label: 'MALASIA ',
    value: 'MY'
  },
  {
    label: 'MALAWI (REPUBLICA DE) ',
    value: 'MW'
  },
  {
    label: 'MALDIVAS (REPUBLICA DE) ',
    value: 'MV'
  },
  {
    label: 'MALI (REPUBLICA DE) ',
    value: 'ML'
  },
  {
    label: 'MALTA (REPUBLICA DE) ',
    value: 'MT'
  },
  {
    label: 'MARRUECOS (REINO DE) ',
    value: 'MA'
  },
  {
    label: 'MARTINICA (DEPARTAMENTO DE) (FRANCIA) ',
    value: 'MQ'
  },
  {
    label: 'MAURICIO (REPUBLICA DE) ',
    value: 'MU'
  },
  {
    label: 'MAURITANIA (REPUBLICA ISLAMICA DE) ',
    value: 'MR'
  },
  {
    label: 'MAYOTTE ',
    value: 'YT'
  },
  {
    label: 'MEXICO (ESTADOS UNIDOS MEXICANOS) ',
    value: 'MX'
  },
  {
    label: 'MOLDAVIA (REPUBLICA DE) ',
    value: 'MD'
  },
  {
    label: 'MONACO (PRINCIPADO DE) ',
    value: 'MC'
  },
  {
    label: 'MONGOLIA ',
    value: 'MN'
  },
  {
    label: 'MONSERRAT (ISLA) ',
    value: 'MS'
  },
  {
    label: 'MONTENEGRO ',
    value: 'ME'
  },
  {
    label: 'MOZAMBIQUE (REPUBLICA DE) ',
    value: 'MZ'
  },
  {
    label: 'MYANMAR (UNION DE) ',
    value: 'MM'
  },
  {
    label: 'NAMIBIA (REPUBLICA DE) ',
    value: 'NA'
  },
  {
    label: 'NAURU ',
    value: 'NR'
  },
  {
    label: 'NAVIDAD (CHRISTMAS) (ISLAS) ',
    value: 'CX'
  },
  {
    label: 'NEPAL (REINO DE) ',
    value: 'NP'
  },
  {
    label: 'NICARAGUA (REPUBLICA DE) ',
    value: 'NI'
  },
  {
    label: 'NIGER (REPUBLICA DE) ',
    value: 'NE'
  },
  {
    label: 'NIGERIA (REPUBLICA FEDERAL DE) ',
    value: 'NG'
  },
  {
    label: 'NIVE (ISLA) ',
    value: 'NU'
  },
  {
    label: 'NORFOLK (ISLA) ',
    value: 'NF'
  },
  {
    label: 'NORUEGA (REINO DE) ',
    value: 'NO'
  },
  {
    label: 'NUEVA CALEDONIA (TERRITORIO FRANCES DE ULTRAMAR) ',
    value: 'NC'
  },
  {
    label: 'NUEVA ZELANDIA ',
    value: 'NZ'
  },
  {
    label: 'OMAN (SULTANATO DE) ',
    value: 'OM'
  },
  {
    label: 'PACIFICO, ISLAS DEL (ADMON  E.U.A.) ',
    value: 'PIK'
  },
  {
    label: 'PAISES BAJOS (REINO DE LOS) (HOLANDA) ',
    value: 'NL'
  },
  {
    label: 'PAKISTAN (REPUBLICA ISLAMICA DE) ',
    value: 'PK'
  },
  {
    label: 'PALAU (REPUBLICA DE) ',
    value: 'PW'
  },
  {
    label: 'PALESTINA ',
    value: 'PS'
  },
  {
    label: 'PANAMA (REPUBLICA DE) ',
    value: 'PA'
  },
  {
    label: 'PAPUA NUEVA GUINEA (ESTADO INDEPENDIENTE DE) ',
    value: 'PG'
  },
  {
    label: 'PARAGUAY (REPUBLICA DEL) ',
    value: 'PY'
  },
  {
    label: 'PERU (REPUBLICA DEL) ',
    value: 'PE'
  },
  {
    label: 'PITCAIRNS (ISLAS DEPENDENCIA BRITANICA) ',
    value: 'PN'
  },
  {
    label: 'POLINESIA FRANCESA ',
    value: 'PF'
  },
  {
    label: 'POLONIA (REPUBLICA DE) ',
    value: 'PL'
  },
  {
    label: 'PORTUGAL (REPUBLICA PORTUGUESA) ',
    value: 'PT'
  },
  {
    label: 'PUERTO RICO (ESTADO LIBRE ASOCIADO DE LA COMUNIDAD DE) ',
    value: 'PR'
  },
  {
    label: 'QATAR (ESTADO DE) ',
    value: 'QA'
  },
  {
    label: 'REINO UNIDO DE LA GRAN BRETAÑA E IRLANDA DEL NORTE ',
    value: 'GB'
  },
  {
    label: 'REPUBLICA CHECA ',
    value: 'CZ'
  },
  {
    label: 'REPUBLICA CENTROAFRICANA ',
    value: 'CF'
  },
  {
    label: 'REPUBLICA DEMOCRATICA POPULAR LAOS ',
    value: 'LA'
  },
  {
    label: 'REPUBLICA DE SERBIA ',
    value: 'RS'
  },
  {
    label: 'REPUBLICA DOMINICANA ',
    value: 'DO'
  },
  {
    label: 'REPUBLICA ESLOVACA ',
    value: 'SK'
  },
  {
    label: 'REPUBLICA POPULAR DEL CONGO ',
    value: 'CD'
  },
  {
    label: 'REPUBLICA RUANDESA ',
    value: 'RW'
  },
  {
    label: 'REUNION (DEPARTAMENTO DE LA) (FRANCIA) ',
    value: 'RE'
  },
  {
    label: 'RUMANIA ',
    value: 'RO'
  },
  {
    label: 'RUSIA (FEDERACION RUSA) ',
    value: 'RU'
  },
  {
    label: 'SAHARA OCCIDENTAL (REPUBLICA ARABE SAHARAVI DEMOCRATICA) ',
    value: 'EH'
  },
  {
    label: 'SAMOA (ESTADO INDEPENDIENTE DE) ',
    value: 'WS'
  },
  {
    label: 'SAMOA AMERICANA ',
    value: 'AS'
  },
  {
    label: 'SAN BARTOLOME ',
    value: 'BL'
  },
  {
    label: 'SAN CRISTOBAL Y NIEVES (FEDERACION DE) (SAN KITTS-NEVIS) ',
    value: 'KN'
  },
  {
    label: 'SAN MARINO (SERENISIMA REPUBLICA DE) ',
    value: 'SM'
  },
  {
    label: 'SAN MARTIN ',
    value: 'MF'
  },
  {
    label: 'SAN PEDRO Y MIQUELON ',
    value: 'PM'
  },
  {
    label: 'SAN VICENTE Y LAS GRANADINAS ',
    value: 'VC'
  },
  {
    label: 'SANTA ELENA ',
    value: 'SH'
  },
  {
    label: 'SANTA LUCIA ',
    value: 'LC'
  },
  {
    label: 'SANTO TOME Y PRINCIPE (REPUBLICA DEMOCRATICA DE) ',
    value: 'ST'
  },
  {
    label: 'SENEGAL (REPUBLICA DEL) ',
    value: 'SN'
  },
  {
    label: 'SEYCHELLES (REPUBLICA DE LAS) ',
    value: 'SC'
  },
  {
    label: 'SIERRA LEONA (REPUBLICA DE) ',
    value: 'SL'
  },
  {
    label: 'SINGAPUR (REPUBLICA DE) ',
    value: 'SG'
  },
  {
    label: 'SIRIA (REPUBLICA ARABE) ',
    value: 'SY'
  },
  {
    label: 'SOMALIA ',
    value: 'SO'
  },
  {
    label: 'SRI LANKA (REPUBLICA DEMOCRATICA SOCIALISTA DE) ',
    value: 'LK'
  },
  {
    label: 'SUDAFRICA (REPUBLICA DE) ',
    value: 'ZA'
  },
  {
    label: 'SUDAN (REPUBLICA DEL) ',
    value: 'SD'
  },
  {
    label: 'SUECIA (REINO DE) ',
    value: 'SE'
  },
  {
    label: 'SUIZA (CONFEDERACION) ',
    value: 'CH'
  },
  {
    label: 'SURINAME (REPUBLICA DE) ',
    value: 'SR'
  },
  {
    label: 'SWAZILANDIA (REINO DE) ',
    value: 'SZ'
  },
  {
    label: 'TADJIKISTAN (REPUBLICA DE) ',
    value: 'TJ'
  },
  {
    label: 'TAILANDIA (REINO DE) ',
    value: 'TH'
  },
  {
    label: 'TAIWAN (REPUBLICA DE CHINA) ',
    value: 'TW'
  },
  {
    label: 'TANZANIA (REPUBLICA UNIDA DE) ',
    value: 'TZ'
  },
  {
    label: 'TERRITORIOS BRITANICOS DEL OCEANO INDICO ',
    value: 'IO'
  },
  {
    label: 'TERRITORIOS FRANCESES, AUSTRALES Y ANTARTICOS ',
    value: 'TF'
  },
  {
    label: 'TIMOR ORIENTAL ',
    value: 'TL'
  },
  {
    label: 'TOGO (REPUBLICA TOGOLESA) ',
    value: 'TG'
  },
  {
    label: 'TONGA (REINO DE) ',
    value: 'TO'
  },
  {
    label: 'TRINIDAD Y TOBAGO (REPUBLICA DE) ',
    value: 'TT'
  },
  {
    label: 'TUNEZ (REPUBLICA DE) ',
    value: 'TN'
  },
  {
    label: 'TURCAS Y CAICOS (ISLAS) ',
    value: 'TC'
  },
  {
    label: 'TURKMENISTAN (REPUBLICA DE) ',
    value: 'TM'
  },
  {
    label: 'TURQUIA (REPUBLICA DE) ',
    value: 'TR'
  },
  {
    label: 'TUVALU (COMUNIDAD BRITANICA DE NACIONES) ',
    value: 'TV'
  },
  {
    label: 'UCRANIA ',
    value: 'UA'
  },
  {
    label: 'UGANDA (REPUBLICA DE) ',
    value: 'UG'
  },
  {
    label: 'URUGUAY (REPUBLICA ORIENTAL DEL) ',
    value: 'UY'
  },
  {
    label: 'UZBEJISTAN (REPUBLICA DE) ',
    value: 'UZ'
  },
  {
    label: 'VANUATU ',
    value: 'VU'
  },
  {
    label: 'VENEZUELA (REPUBLICA DE) ',
    value: 'VE'
  },
  {
    label: 'VIETNAM (REPUBLICA SOCIALISTA DE) ',
    value: 'VN'
  },
  {
    label: 'VIRGENES  ISLAS (BRITANICAS) ',
    value: 'VG'
  },
  {
    label: 'VIRGENES  ISLAS (NORTEAMERICANAS) ',
    value: 'VI'
  },
  {
    label: 'YEMEN (REPUBLICA DE) ',
    value: 'YE'
  },
  {
    label: 'ZAMBIA (REPUBLICA DE) ',
    value: 'ZM'
  },
  {
    label: 'ZIMBABWE (REPUBLICA DE) ',
    value: 'ZW'
  }
];

export default PaisesOptions;